exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".matching-posts-count{color:var(--wf-primary);font-weight:400;margin-left:1rem}", ""]);

// exports
